export default __webpack_public_path__ + "static/media/user.37cd8b0c.png";